// vi_vn.js越南语文件
export default {
	message: {
		language: 'Ngôn ngữ',
		plogin: 'Vui lòng đăng nhập trước!',
		login: 'Đăng nhập',
		login1: 'Đăng nhập ngay',
		logintips: 'Trải nghiệm nhiều dịch vụ hơn sau khi đăng nhập',
		register: 'Đăng ký',
		register1: 'Đăng ký ngay',
		loginout: 'Thoát',
		join: 'Tham gia',
		days: 'Ngày',
		lastip: 'Đăng nhập lần cuối IP',
		account: 'Số tài khoản',
		game: 'Trò chơi',
		video: 'Việt',
		collect: 'Bộ sưu tập',
		Favorite: 'Bộ sưu tập',
		collect1: 'Yêu thích',
		share: 'Chia sẻ',
		sharelive: 'Chia sẻ trực tiếp',
		Cache: 'Bộ nhớ tạm',
		download: 'Tải về',
		wallet: 'Ví tiền',
		recharge: 'Nạp tiền',
		withdraw: 'Rút tiền',
		noble: 'Quý tộc',
		record: 'Hồ sơ',
		RechargeTime: 'Thời gian nạp tiền',
		WithdrawalTime: 'Thời gian rút tiền',
		RechargeRecord: 'Hồ sơ nạp tiền',
		WithdrawalRecords: 'Hồ sơ rút tiền',
		TransactionRecords: 'Hồ sơ giao dịch',
		business: 'Kinh doanh',
		message: 'Tin nhắn',
		activity: 'ƯU ĐÃI',
		setting: 'Thiết lập',
		help: 'Trợ giúp',
		version: 'Phiên bản',
		loggingout: 'Đăng nhập',
		remember: 'Ghi nhớ mật khẩu',
		forget: 'Quên mật khẩu',
		noaccount: 'Không có tài khoản',
		returnhome: 'Quay lại trang đầu',
		bottomtips: 'Tập đoàn được quản lý và hoạt động hợp pháp bởi PAGCOR của Philippines và Hiệp hội Cờ bạc Đảo Man của Vương quốc Anh.',
		days21: 'Trên 21 tuổi, đã đọc và đồng ý',
		rules: 'Quy tắc&Điều khoản',
		hadaccount: 'Đã có tài khoản',
		gonggao: 'Thông báo',
		system: 'Hệ thống',
		home: 'Trang chủ',
		kefu: 'Dịch vụ',
		kefuCenter: 'Dịch vụ khách hàng',
		mykf1desc: 'Xin vui lòng tải về ứng dụng độc quyền dưới đây Thêm ID Liên hệ với tôi',
		mykf2desc: 'Địa chỉ download',
		mykf3desc1: 'Hỗ trợ trực tuyến',
		mykf3desc2: 'Click để bắt đầu chat online',
		mykf3desc3: 'Xử lý các vấn đề về nạp tiền, rút tiền và trò chơi.',
		my: 'Của tôi',
		close: 'Đóng cửa',
		zuixin: 'Mới nhất',
		yhdetail: 'Chi tiết ưu đãi',
		mywallet: 'Ví của tôi',
		zichan: 'Tài sản',
		yuan: 'Nguyên',
		zxwallet: 'Ví trung tâm',
		ptwallet: 'Ví nền tảng',
		transfer: 'Chuyển khoản',
		LimitTransfer: 'Hạn mức chuyển khoản',
		cards: 'Quản lý gói thẻ',
		gamebalance: 'Số dư trò chơi',
		onerecycle: 'Tái chế One-Click',
		Recovery: 'Số tiền thu hồi',
		Recycling: 'Tái chế',
		wei: 'Việt',
		loading: 'Đang tải',
		refreshing: 'Đang cập nhật',
		refreshend: 'Làm mới thành công',
		success: 'Hoạt động thành công',
		czamount: 'Số tiền nạp',
		limit: 'Giới hạn',
		saccount: 'Chọn tài khoản',
		skbank: 'Ngân hàng nhận tiền',
		skname: 'Tên người nhận',
		copy: 'Sao chép',
		skcard: 'Số thẻ thu tiền',
		submit: 'Giới thiệu',
		Confirmsubmit: 'Xác nhận nộp',
		nextstep: 'Tiếp theo',
		customerservice: 'Hỗ trợ nhân tạo',
		pleasecontact: 'Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ',
		copysuccess: 'Đã sao chép thành công vào bảng cắt',
		copyfail: 'Sao chép thất bại',
		firstmoney: 'Vui lòng nhập số tiền nạp trước',
		rechargelowtips: 'Số tiền nạp không được nhỏ hơn mức tối thiểu',
		rechargeuptips: 'Số tiền nạp không được vượt quá giới hạn tối đa',
		firstaccount: 'Vui lòng chọn tài khoản trước',
		selwallet: 'Chọn ví',
		firstoutwallet: 'Vui lòng chọn Chuyển ví ra trước',
		retract: 'Thu gọn',
		expend: 'Mở rộng',
		mzmodel: 'Chế độ quay miễn phí',
		mzmodeltips: 'Sau khi mở số dư sẽ tự động chuyển vào sân chơi.',
		seloutwallet: 'Chuyển ví',
		selinwallet: 'Chuyển sang ví',
		transfertips: 'Không thể trao đổi ví với nhau',
		maxamount: 'Số tiền tối đa',
		codings: 'Kích thước',
		washingAmount: 'Số lượng giặt',
		withamount: 'Số tiền rút ra',
		banks: 'Thẻ ngân hàng',
		withzhtips: 'Vui lòng liên kết tài khoản rút tiền trước',
		withmoneytips: 'Vui lòng nhập số tiền rút trước',
		add: 'Thêm',
		antoken1: 'Ví tiền ảo trực tuyến hàng đầu thế giới, nạp tiền và rút tiền tự động trực tiếp vào tài khoản, giao dịch chuyển tiền nhanh hơn và an toàn hơn',
		antoken2: 'Tải xuống ứng dụng ví cá nhân AnToken: Nhấp để truy cập trực tiếp vào địa chỉ web',
		antoken3: 'https://antoken.pro',
		cardtips: 'Gợi ý ấm áp: Mỗi tài khoản chỉ có thể ràng buộc 5 tấm, nếu như sửa đổi xin xóa bỏ rồi thêm lại!',
		walletaddress: 'Địa chỉ ví',
		walletaddressdesc: 'Vui lòng điền địa chỉ K-Bean của 34 chữ số đầu EC',
		USDTaddress: 'Địa chỉ USDT',
		unbindingtips: 'Có chắc là muốn cởi trói không?',
		paypass: 'Mật khẩu thanh toán',
		cardprotocol: 'Giao thức ví',
		cardaddress: 'Địa chỉ ví',
		Cardholder: 'Chủ thẻ',
		bankcard: 'Số thẻ ngân hàng',
		bankname: 'Mở tài khoản ngân hàng',
		banknamedesc: 'Vui lòng chọn ngân hàng mở tài khoản',
		bankaddress: 'Địa chỉ mở tài khoản',
		bankaddressdesc: 'Vui lòng chọn địa chỉ mở tài khoản',
		bankother: 'Chi nhánh mở tài khoản',
		firstpaypass: 'Vui lòng nhập mật khẩu thanh toán',
		bindtips: 'Vui lòng điền đầy đủ thông tin, không thay đổi sau khi bị ràng buộc',
		Paymentcode: 'Mã thu tiền',
		platname: 'Giải trí Đằng Đạt',
		records: 'Ghi chép đầy đủ',
		gameRecord: 'Lịch sử trò chơi',
		betrecord: 'Đặt cược trò chơi',
		betDetail: 'Chi tiết đặt cược',
		accountsetting: 'Thiết lập tài khoản',
		messages: 'Tin nhắn',
		returnrecord: 'Hồ sơ trở lại nước',
		transferrecord: 'Hồ sơ chuyển tiền',
		activityrecord: 'Hồ sơ ứng tuyển sự kiện',
		applyfor: 'Ứng dụng',
		welfare: 'Phong bì màu đỏ',
		query: 'Yêu cầu',
		Time: 'Thời gian',
		To: 'Đến',
		dllogin: 'Đăng nhập proxy',
		outsuccess: 'Thoát thành công',
		today: 'Hôm nay',
		days7: 'Gần 7 ngày',
		days14: 'Gần 14 ngày',
		days30: 'Gần 30 ngày',
		cunkuan: 'Tiền gửi',
		qukuan: 'Rút tiền',
		ordersn: 'Số thứ tự',
		money: 'Số lượng',
		state: 'Trạng thái',
		nomore: 'Không còn nữa.',
		More: 'Thêm',
		SeeMore: 'Xem thêm',
		Detail: 'Xem chi tiết',
		Changebatch: 'Đổi một mẻ khác.',
		Lovely: 'Đoán là anh thích.',
		selplatform: 'Chọn Platform',
		betamount: 'Số tiền đặt cược',
		betgame: 'Trò chơi',
		betresult: 'Kết quả cá cược',
		perfect1: 'Hoàn thiện thông tin tài khoản, an toàn hơn',
		perfect2: 'Hoàn thiện Profile',
		perfect3: 'Thông tin đầy đủ hơn, dịch vụ của chúng tôi chu đáo hơn',
		perfect4: 'Hoàn thiện',
		binding: 'Ràng buộc',
		AddBinding: 'Thêm ràng buộc',
		carding1: 'Quản lý thẻ',
		carding2: 'Để rút tiền mặt, vui lòng liên kết thẻ ngân hàng hoặc địa chỉ tiền ảo',
		logpassword1: 'Mật khẩu đăng nhập',
		logpassword2: 'Thay đổi mật khẩu đăng nhập thường xuyên, bảo mật tài khoản thuận lợi',
		paypassword1: 'Mật khẩu thanh toán',
		paypassword2: 'Thay đổi mật khẩu thanh toán thường xuyên, bảo mật tài khoản thuận lợi',
		oldloginpass: 'Mật khẩu đăng nhập gốc',
		newloginpass: 'Mật khẩu đăng nhập mới',
		oldloginpassdesc: 'Vui lòng nhập mật khẩu đăng nhập ban đầu',
		newloginpassdesc: 'Vui lòng nhập mật khẩu đăng nhập mới',
		confirmpass: 'Xác nhận mật khẩu',
		confirmpassdesc: 'Vui lòng nhập mật khẩu xác nhận',
		oldpaypass: 'Mật khẩu thanh toán gốc',
		newpaypass: 'Mật khẩu thanh toán mới',
		oldpaypassdesc: 'Vui lòng nhập mật khẩu thanh toán ban đầu',
		newpaypassdesc: 'Vui lòng nhập mật khẩu thanh toán mới',
		personalinformation: 'Sửa tài liệu',
		edit: 'Chỉnh sửa',
		SelectAll: 'Chọn tất cả',
		Delete: 'Xoá',
		avatar: 'Upload ảnh đại diện',
		username: 'Người dùng',
		userID: 'ID người dùng',
		userIDdesc: 'Vui lòng nhập User ID',
		username1: 'Tên người dùng',
		realname: 'Tên',
		nickname: 'Biệt danh',
		realname2: 'Tên',
		realname1: 'Tên hoặc nickname',
		realname1desc: 'Vui lòng nhập tên hoặc nickname',
		realnamedesc: 'Vui lòng nhập tên',
		nicknamedesc: 'Vui lòng nhập nickname',
		sex: 'Giới tính',
		birthday: 'Sinh nhật',
		birthdaydesc: 'Vui lòng chọn ngày sinh',
		email: 'Hộp thư',
		phone: 'Điện thoại',
		nationality: 'Quốc tịch',
		nationalitydesc: 'Vui lòng nhập quốc tịch',
		education: 'Giáo dục',
		educationdesc: 'Vui lòng nhập bằng cấp',
		AnnualSalary: 'Lương hàng năm',
		AnnualSalarydesc: 'Vui lòng nhập lương hàng năm',
		work: 'Công việc',
		workdesc: 'Vui lòng nhập công việc',
		RegistrationTime: 'Thời gian đăng ký',
		LastLogin: 'Đăng nhập',
		operate: 'Hoạt động',
		mail: 'Thư trong trạm',
		allplat: 'Toàn bộ nền tảng',
		upgrade: 'Nâng cấp',
		draw: 'Vẽ tranh',
		Received: 'Đã nhận',
		totaldraw: 'Tích lũy lĩnh',
		undraw: 'Không thoát nước',
		transin: 'Chuyển tiếp',
		transout: 'Chuyển ra',
		transtype: 'Chọn loại giao dịch',
		walfareinfo: 'Tình hình phong bì đỏ',
		help1: 'Chào thành viên thân mến',
		help2: 'Chào mừng đến với Help Center',
		help3: 'Nếu vấn đề vẫn chưa được giải quyết, bạn có thể tư vấn trực tuyến.',
		ungot: 'Không đạt tiêu chuẩn',
		got: 'Đã đạt tiêu chuẩn',
		totalrecharge: 'Tổng giá trị nạp',
		totalwater: 'Tích lũy nước chảy',
		waterratio: 'Tỷ lệ trở lại nước',
		jinji: 'Khuyến mãi',
		lijin: 'Tiền thưởng',
		level: 'Lớp',
		hot: 'Nóng bỏng',
		live: 'CASINO',
		slot: 'Điện tử',
		chess: 'Cờ vua',
		sports: 'THỂ THAO',
		lottery: 'Xổ số',
		fishing: 'BẮN CÁ',
		actrules: 'Quy tắc hoạt động',
		accountlogin: 'Tài khoản Mật khẩu Đăng nhập',
		mobilelogin: 'Đăng nhập nhanh cho điện thoại',
		password: 'Mật khẩu',
		newpassword: 'Mật khẩu mới',
		pleaseaccount: 'Vui lòng nhập tên tài khoản',
		passtips: 'Mật khẩu dài 6-15 ký tự và phải bao gồm chữ cái và số!',
		pleasepass: 'Vui lòng nhập mật khẩu',
		pleasetwcode: 'Vui lòng nhập mã xác minh văn bản',
		country: 'Quốc gia/Số điện thoại di động',
		pleasemobile: 'Vui lòng nhập số điện thoại',
		yzm: 'CAPTCHA',
		pleaseyzm: 'Vui lòng nhập mã xác minh điện thoại',
		sendcode: 'Gửi CAPTCHA',
		currency: 'Tiền tệ',
		usernametips: 'Vui lòng nhập 4-16 ký tự, bao gồm cả tiếng Anh',
		currencytips: 'Vui lòng nhập tiền',
		againpass: 'Nhập lại mật khẩu trên',
		ckmoney: 'Số tiền nạp',
		ckdate: 'Ngày nạp tiền',
		redmoney: 'Số lượng phong bì màu đỏ',
		activitycenter: 'Hoạt động',
		lucrative: 'Khuyến mãi',
		MemberManagement: 'Quản lý thành viên',
		CommissionSettlement: 'Thanh toán hoa hồng',
		CommissionRecords: 'Hồ sơ hoa hồng',
		FriendTransfer: 'Chuyển tiền bạn bè',
		nightMode: 'Chế độ đêm khuya',
		Mobileauth: 'Chứng nhận điện thoại di động',
		Certified: 'Chứng nhận',
		nodata: 'Không có dữ liệu.',
		Sportslive: 'Thể thao trực tiếp',
		MemberID: 'ID thành viên',
		MemberIDdesc: 'Vui lòng nhập ID thành viên',
		friendID: 'ID bạn thân',
		friendIDdesc: 'Vui lòng nhập ID bạn bè hoặc số điện thoại di động',
		findMember: 'Tìm lại thành viên',
		Platformfees: 'Phí nền tảng',
		PromotionalMaterials: 'Quảng bá tài liệu',
		copylink: 'Sao chép liên kết',
		SaveQRcode: 'Lưu mã QR',
		interest: 'Tập trung',
		eliminate: 'Loại bỏ',
		Recommend: 'Giới thiệu',
		new: 'Mới',
		searchfor: 'Tìm kiếm',
		searchfordesc: 'Vui lòng nhập nội dung tìm kiếm',
		find: 'Tìm kiếm',
		results: 'Tìm kết quả',
		Cashier: 'Quầy thanh toán',
		skip: 'Bỏ qua',
		Enterimmediately: 'Nhập ngay',
		APPlock: 'Khóa ứng dụng APP',
		actTime: 'Thời gian hoạt động',
		confirm: 'Xác định',
		platformtype: 'Loại nền tảng',
		orderState: 'Trạng thái đặt hàng',
		gameName: 'Tên trò chơi',
		gameNamedesc: 'Vui lòng nhập tên trò chơi',
		bettime: 'Thời gian đặt cược',
		validamount: 'Số tiền đặt cược',
		winloss: 'Số tiền trúng thưởng',
		betnum: 'Trò chơi Số đơn',
		normal: 'Bình thường',
		abnormal: 'Không bình thường',
		betTotal: 'Tổng số tiền đặt cược',
		winTotal: 'Tổng số tiền thắng',
		Orderamount: 'Số tiền đặt hàng',
		Orderbet: 'Đặt cược đơn',
		male: "Nam",
		female: "Phụ nữ",
		electron: "Trò chơi điện tử",
		Dailyvideo: "Đề xuất video hàng ngày",
		Choicevideo: "Đề xuất chọn lọc",
		videoList1: "Cập nhật mới nhất hàng ngày",
		videoList2: "Video phổ biến nhất",
		videoList3: "Video ngắn",
		mydata1: "Số ngày VIP",
		mydata2: "Số tiền được trả lại nước",
		waterAmount: "Số tiền trả lại nước",
		waterDate: "Ngày trở lại nước",
		noblet1: 'Nâng cấp VIP ngay lập tức Full Station HD Không giới hạn',
		noblet2: 'Đến trước phải đến trước, mau đến tranh mua đi.',
		noblet3: 'Vô hạn xem, tặng',
		noblet4: 'Xem hồ sơ mua VIP',
		noblet5: 'Nhấp vào đây',
		order1: 'Thứ hai',
		Transamount: 'Số tiền có thể chuyển',
		Dailylimit: 'Giới hạn một ngày',
		vipIDdesc: 'Vui lòng nhập ID thành viên hoặc số điện thoại di động',
		Transferaccount: 'Chuyển tài khoản',
		Transfermoney: 'Chuyển khoản',
		Transfert1: 'Lưu ý: Tham gia chương trình ưu đãi, giới hạn rút tiền sẽ không được vào tài khoản',
		Transfert2: 'Lưu ý: Sau khi gửi thành công, hệ thống sẽ đến tài khoản trong vòng 10 phút, nếu chưa, vui lòng liên hệ với dịch vụ khách hàng.',
		amount: 'Số lượng',
		receiptTime: 'Thời gian thanh toán',
		Transferfriends: 'Chuyển bạn bè',
		Transferringfriends: 'Chuyển sang bạn bè',
		Descriptive: 'Mô tả thông tin',
		exchangerate: 'Tỷ giá thời gian thực',
		Accountbalance: 'Số dư tài khoản',
		withdrawal: 'Số lượng cần thiết để rút tiền',
		commission: 'Phí xử lý',
		Exchangerate: 'Tính toán tỷ giá hối đoái',
		illustrate: 'Mô tả',
		withdrawtilt1: 'Thấp nhất là 100 lần, nếu chưa đến sổ sách xin liên hệ kịp thời với dịch vụ chăm sóc khách hàng trực tuyến.',
		withdrawtilt2: 'Thẻ rút tiền phải là thẻ của người thật, nếu không không thể vào tài khoản.',
		tips: 'Mẹo',
		findvipt1: 'Thông qua chức năng này có thể tìm lại thành viên cấp dưới không bị ràng buộc thành công.',
		findvipt2: 'Giới hạn thời gian đăng ký thành viên cấp dưới trong vòng 3 ngày.',
		Totalplatformcost: 'Tổng chi phí nền tảng',
		Winlamount: 'Số tiền thắng và thua',
		PlatformRate: 'Giá nền tảng',
		totalExpenses: 'Tổng chi phí',
		commission1: 'Tỷ lệ hoa hồng hiện tại',
		commission2: 'Tỷ lệ hoa hồng',
		Mycommission: 'Hoa hồng của tôi',
		totalRecharge: 'Tổng giá trị nạp',
		totalWithdraw: 'Tổng số rút tiền',
		totalPeople: 'Số lượng thành viên',
		activePeople: 'Thành viên tích cực',
		addPeople: 'Mới trong tháng này',
		SettlementDate: 'Ngày giải quyết',
		DayMonth: 'Ngày/tháng',
		ImmeSettle: 'Giải quyết ngay',
		Formula: 'Công thức tính toán',
		SettleMoney: 'Số tiền hoa hồng đã nhận',
		Date: 'Ngày',
		authname: 'Tên chứng nhận',
		authnamedesc: 'Vui lòng điền tên người gửi tiền',
		hashelp: 'Cần giúp đỡ',
		contact: 'Liên hệ Hỗ trợ',
		Agreement: 'Thỏa thuận/Tiền tệ',
		ckNumber: 'Số tiền gửi',
		cbaddress: 'Địa chỉ nạp tiền',
		notes: 'Ghi chú',
		Scancoins: 'Quét mã nạp tiền',
		content: 'Nội dung',
		ckdesc: 'Vui lòng nhập chi tiết tiền gửi',
		zfAccount: 'Tài khoản thanh toán',
		zfbank: 'Ngân hàng thanh toán',
		banktype: 'Loại nạp tiền',
		banktypedesc: 'Vui lòng chọn loại nạp tiền',
		zzzh: 'Chuyển tài khoản',
		zjzh: 'Chuyển vào tài khoản',
		whole: 'Tất cả',
		zzmoney: 'Số tiền chuyển khoản',
		zhtime: 'Thời gian chuyển tiền',
		zzpt: 'Nền tảng chuyển tiền',
		Paymentmethod: 'Phương thức thanh toán',
		behalf: 'Bạn thân trả',
		saccountdesc: 'Vui lòng chọn tài khoản nhận tiền',
		cztips: 'Xin vui lòng gửi số tiền chuyển khoản đến tài khoản trên rồi nộp đơn, nhân viên công tác sẽ làm ngay cho bạn.',
		currency1: 'Tiền tệ',
		exchangeRate1: 'Tỷ giá hối đoái',
		Rebate: 'Trả lại',
		Receive1: 'Nạp tiền vào tài khoản',
		PaymentVoucher: 'Tải lên phiếu thanh toán',
		DepositTime: 'Thời gian nạp tiền',
		DepositTimedesc: 'Vui lòng chọn thời gian nạp tiền',
		BlockchainID: 'Blockchain ID',
		BlockchainIDdesc: 'Vui lòng nhập ID Blockchain',
		tradeID: 'Sáu chữ số sau ID giao dịch',
		tradeIDdesc: 'Vui lòng nhập 6 chữ số sau ID giao dịch',
		withdraw1: 'Rút tiền mặt.',
		gamenoIndesc: 'Trò chơi đang được bảo trì. Vui lòng thử lại sau',
		cznamedesc1: 'Lần đầu tiên nạp tiền online, phải ràng buộc tên thật.',
		cznamedesc2: 'Hãy chắc chắn rằng tên này phù hợp với tên của người gửi tiền, nếu không bạn không thể truy cập vào tài khoản.',
		cznamedesc3: 'Sau khi gửi lưu, không thể thay đổi, vui lòng điền cẩn thận.',
		txnamedesc1: 'Lần đầu tiên, thông tin phải được ràng buộc với tên thật.',
		txnamedesc2: 'Hãy chắc chắn rằng tên này trùng với tên của người rút tiền, nếu không bạn không thể truy cập vào tài khoản.',
		txnamedesc3: 'Sau khi gửi lưu, không thể thay đổi, vui lòng điền cẩn thận.',
		modify: 'Sửa đổi',
		inviteId: 'Mã mời',
		findpaypass: 'Lấy lại mật khẩu thanh toán',
		Movies: 'Phim ảnh',
		rakeback: 'Trở lại nước',
		rescue: 'Cứu hộ',
		RedeemCode: 'Mã đổi',
		dhTitle: 'Hồ sơ trao đổi của tôi',
		dhtxt: 'Chuyển đổi',
		dhtxtbtn: 'Đổi ngay',
		dhtxtdesc: 'Nhập mã đổi',
		dhmoney: 'Số tiền trao đổi',
		dhlsbs: 'Số lượng nước chảy',
		lqtime: 'Nhận thời gian',
		free: 'Miễn phí',
		zznamedesc1: 'Hãy chắc chắn điền tên thật của người chuyển tiền, nếu không sẽ không thể tự động vào tài khoản.',
		zznamedesc2: 'Nếu trong vòng 10 phút, số tiền bổ sung chưa tới, xin liên hệ với dịch vụ khách hàng trực tuyến.',
		tgrs: 'Số lượng khuyến mãi hiện tại',
		tglink: 'Liên kết quảng cáo',
		tgyqewm: 'Mã QR mời',
		wxts: 'Gợi ý ấm áp',
		tgtips1: 'Để đăng ký tên miền độc lập, vui lòng liên hệ với ủy viên đại diện.',
		tgtips2: 'Nếu bạn là quản trị viên web và cần tài liệu quảng cáo, vui lòng liên hệ với dịch vụ khách hàng.',
		tgtips3: 'Mời bạn bè đăng ký, chỉ cần yêu cầu bạn bè của bạn điền vào mã mời khi đăng ký.',
		mycenter: 'Trung tâm cá nhân',
		myInfo: 'Thông tin cá nhân',
		mylucrative: 'Khuyến mãi của tôi',
		Security: 'Bảo mật tài khoản',
		timeframe: 'Khoảng thời gian',
		starttime: 'Thời gian bắt đầu',
		endtime: 'Thời gian kết thúc',
		Keysdesc: "Vui lòng chọn quốc gia",
		Keysdesc1: "Vui lòng chọn mã vùng",
		rule1: 'Trên 21 tuổi, đã đọc và đồng ý',
		rule2: '[Quy định và Điều khoản]',
		autotrans: 'Tự động quay miễn phí',
		autotranstips: 'Khi chơi, số dư sẽ tự động được chuyển vào tài khoản trò chơi tương ứng.',
		handtrans: 'Chuyển tiền thủ công',
		handtranstips: 'Để chuyển tiền thủ công, vui lòng tắt [Tự động miễn phí]',
		jytype: 'Loại giao dịch',
		wechat: 'Trang chủ',
		Alipay: 'Thanh toán',
		yjed: 'Hạn mức hoa hồng',
		yjsed: 'Hạn mức thanh toán',
	},
	footer: {
		fkfs: 'Phương thức thanh toán',
		partners: 'Đối tác',
		followUs: 'Theo dõi chúng tôi',
		regauth: 'Cơ quan quản lý',
		pagcor: 'PAGCOR',
		legalage: 'Tuổi hợp pháp',
		cs: 'Dịch vụ',
		telegram: 'Máy bay',
		network: 'Mạng lưới',
		dark: 'Đêm',
		byday: 'Ngày',
		affiliate: 'Liên kết',
		TOP: 'Đầu trang',
		chat: 'Trò chuyện',
	},
	home: {
		hotgametit: "Trò chơi phổ biến",
		activitydesc1: "Đằng Đạt Siêu Lịch Sự",
		activitydesc2: "ọi bạn bè kiếm tiền",
		new: "Mới nhất",
		Chesscardsdesc1: "Cờ vua quốc tế",
		Chesscardsdesc2: "Trải nghiệm chơi game chân thực,",
		Chesscardsdesc3: "Trí tuệ nhân tạo thực tế,",
		Chesscardsdesc4: "Nhiều chế độ và cách chơi mới",
		Chesscardsdesc5: "Trò chơi cờ cao cấp, nền tảng siêu hot......",
		lotterydesc1: "Xổ số",
		lotterydesc2: "Với các trò chơi xổ số cổ điển và sáng tạo,",
		lotterydesc3: "Điều này sẽ làm tăng quá trình chơi của mong muốn",
		onsitedesc1: "LIVE CASINO",
		onsitedesc2: "Với triết lý 'dịch vụ là trên hết', chúng tôi cam kết cung cấp dịch vụ cho nhiều thành viên của mình",
		onsitedesc3: "Trò chơi cá cược trực tuyến phong phú nhất và hệ thống dịch vụ đa dạng và giá trị cao",
		placeholderdesc: "Vui lòng nhập tên trò chơi",
		gogamebtn: "Tham gia trò chơi",
		swgamebtn: "Chơi thử trò chơi",
		swbtn: "Thử chơi",
		egamesdesc1: "Phần mềm Palm Gaming",
		egamesdesc2: "Nhà cung cấp trò chơi điện tử hàng đầu thế giới,",
		egamesdesc3: "Chủ yếu tham gia phát triển trò chơi điện tử ngoại tuyến và trực tuyến.",
		egamesdesc4: "hành phố giải trí lớn nhất châu Á",
		livedesc1: "Casino Live",
		livedesc2: "AG ALLBET  OG DS ",
		livedesc3: "Nền tảng giải trí hàng đầu",
		livedesc4: "Long Hổ, tạc kim hoa, sắc đĩa, phiên quán......",
		livedesc5: "Mang đến cho bạn trải nghiệm sang trọng nhập vai!",
		sportdesc1: "Thể thao",
		sportdesc2: "Hầu hết các loại cược, kinh nghiệm cá cược mạnh nhất,",
		sportdesc3: "Hỗ trợ rút tiền trước thời hạn,",
		sportdesc4: "Thu thập gạo một bước nhanh hơn và suy nghĩ của bạn,",
		sportdesc5: "Vote cho người mình thích",
		fishdesc1: "Câu cá",
		fishdesc2: "Điên cuồng câu cá! Siêu nổ",
		fishdesc3: "Tốc độ, kho báu khổng lồ đang chờ bạn để bắt!",
		tiptitle: 'Nhắc nhở quan trọng',
		tipclose: 'Đóng cửa',
		tipflag: 'Hôm nay không nhắc nhở',
		testdesc1: "Website chính thức mới nhất",
		testdesc2: "Gợi ý ấm áp: Địa chỉ web có giá trị MS nhỏ nhất mở càng nhanh!",
		LinkTimeout: "Thời gian chờ liên kết",
		GoImmediately: "Đi ngay",
		Recheck: "Kiểm tra lại tốc độ truy cập",
		Enter: 'Nhập',
	},
	help: {
		title0: 'Về chúng tôi',
		title1: 'Câu hỏi thường gặp',
		title2: 'Chính sách bảo mật',
		title3: 'Tuyên bố miễn trừ trách nhiệm',
		title4: 'Liên hệ',
		title5: 'Đại lý tham gia',
		title6: 'Trách nhiệm cá cược',
		title7: 'Hợp tác kinh doanh',
		service: 'Hỗ trợ trực tuyến',
		servicedesc: 'Nhanh chóng, thuận tiện và kịp thời cung cấp thông tin liên lạc',
	},
	download: {
		scantxt: 'Quét mã 2 chiều tải xuống APP',
		downtext: "Tải app",
		downdesc: "Mở tài khoản TDBET ngay hôm nay và tận hưởng phần thưởng tốt nhất!",
		version: "Phiên bản",
		ScanCodedown: "Tải xuống APP",
		BeCurrent: "phổ quát",
		H5org: "Ghé thăm trang H5",
	},
	vip: {
		viptitle: "Lên VIP",
		viptitle1: "Lễ hội đỉnh cao",
		viptitle2: "Vinh quang ra khơi",
		viptitle3: "Tham gia VIP với dịch vụ cao cấp",
		vipen: "BECOME A VIP MEMBER AND ENJOY THE MOST HONORBLE SERVICE",
		totalDeposit: "Tổng giá trị nạp",
		totalBet: "Tích lũy nước chảy",
		vipBLdesc: "Tỷ lệ VIP trở lại nước",
		vipgradetitle: "Cấp VIP",
		vipgrade1: "Người thật",
		vipgrade2: "Điện tử",
		vipgrade3: "Trang chủ",
		vipgrade4: "Thể thao",
		vipgrade5: "Xổ số",
		vipgrade6: "Thể thao điện tử",
		ActivityRules: "Quy tắc hoạt động",
		Rulestext1: "Tiêu chuẩn khuyến mãi",
		Rulesdesc1: "Tích lũy tiền gửi ngân hàng của hội viên cùng với tích lũy nước chảy đạt tới yêu cầu cấp bậc tương ứng, có thể thăng cấp VIP tương ứng trước 24 giờ ngày hôm sau.",
		Rulestext2: "Thứ tự khuyến mãi",
		Rulesdesc2: "Đẳng cấp VIP đạt tới yêu cầu tương ứng có thể mỗi ngày thăng cấp một cấp, nhưng đẳng cấp VIP không thể vượt cấp thăng cấp.",
		Rulestext3: "Yêu cầu bảo lãnh",
		Rulesdesc3: "Sau khi hội viên đạt tới đẳng cấp VIP, trong vòng 90 ngày đặt cược cần hoàn thành yêu cầu bảo lãnh nước chảy. Nếu chương trình khuyến mãi được hoàn thành trong thời gian này, các yêu cầu về cấp bậc được tính lại theo cấp độ hiện tại.",
		Rulestext4: "iêu chuẩn hạ cấp",
		Rulesdesc4: "Nếu hội viên trong một quý (tính toán 90 ngày) không hoàn thành yêu cầu bảo lãnh tương ứng, hệ thống sẽ tự động giáng cấp một cấp, nước trở lại tương ứng và các ưu đãi khác cũng sẽ theo đó điều chỉnh đến cấp bậc sau khi giáng cấp.",
		Rulestext5: "Tiền thưởng nâng cấp",
		Rulesdesc5: "Tiền mừng thăng cấp sau khi hội viên đạt tới cấp bậc hội viên này hệ thống tự động phát, tiền mừng thăng cấp mỗi cấp bậc mỗi hội viên chỉ có thể đạt được một lần (tiền mừng thăng cấp gấp một lần nước chảy là có thể rút tiền).",
		Rulestext6: "Quà tặng sinh nhật",
		Rulesdesc6: "Hội viên tổ chức sinh nhật trong vòng ba tháng đăng ký, năm nay sẽ không thể nhận tiền mừng sinh nhật. Những thành viên đăng ký lâu hơn ba tháng sẽ được tự nhận tại trang VIP vào ngày sinh nhật và được nhận mỗi năm một lần. (Tiền mừng sinh nhật gấp 1 lần nước chảy là có thể rút tiền).",
		Rulestext7: "Phong bì màu đỏ hàng tháng",
		Rulesdesc7: "Hội viên tháng trước từng có ít nhất một lần gửi ngân hàng thành công ghi chép, có thể vào ngày 1 và ngày 16 tháng sau lần lượt đến trang VIP nhận 1/2 tiền lì xì mỗi tháng tương ứng (tiền lì xì gấp 1 lần nước chảy là có thể rút tiền)",
		Rulestext8: "Giải trí Đằng Đạt bảo lưu quyền sửa đổi hoạt động, đình chỉ và giải thích cuối cùng.",
		Rulesdesc8: "Ghi chú: Trên đây là số tiền trả lại nước cao nhất của các hội trường, số tiền trả lại nước cụ thể xin lấy trò chơi thực tế làm chuẩn, mỗi ngày trả lại nước sẽ lần lượt được phát vào lúc 15 giờ - 16 giờ ngày hôm sau.",

	},
}


// WEBPACK FOOTER //
// ./src/lang/vi_vn.js